import { useToast } from "./use-toast";
import { useState } from "react";

interface UseVoiceChatProps {
  chatId?: string | null;
}

interface UseVoiceChatReturn {
  voiceToken: string | null;
  isVoiceModalOpen: boolean;
  initializeVoiceChat: () => Promise<void>;
  closeVoiceModal: () => void;
}

export const useVoiceChat = ({
  chatId,
}: UseVoiceChatProps): UseVoiceChatReturn => {
  const [isVoiceModalOpen, setIsVoiceModalOpen] = useState(false);
  const [voiceToken, setVoiceToken] = useState<string | null>(null);
  const { toast } = useToast();

  const initializeVoiceChat = async () => {
    if (!chatId) {
      console.debug("Waiting for chatId to be available");
      return;
    }
    try {
      const generatedRoomName = `user-${Math.random()
        .toString(36)
        .substring(7)}`;
      const response = await fetch(
        `https://app.outsella.com/api/livekit/token?roomName=${generatedRoomName}&participantName=${chatId}`
      );
      const data = await response.json();
      setVoiceToken(data.accessToken);
      setIsVoiceModalOpen(true);
    } catch (error) {
      console.error("Failed to initialize voice chat:", error);
      toast({
        title: "Error",
        description: "Failed to initialize voice chat",
        variant: "destructive",
      });
    }
  };

  const closeVoiceModal = () => {
    setIsVoiceModalOpen(false);
    setVoiceToken(null);
  };

  return {
    voiceToken,
    isVoiceModalOpen,
    initializeVoiceChat,
    closeVoiceModal,
  };
};
